module.exports = {"title":"Videos Management","description":"Copy the Youtube Video ID and paste it in the corresponding field.","videoTitle":"Video title","youtubeId":"YoutubeID (i.e. Ut6lCOXBkfg)","addVideo":"Add Video","save":"Save"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Videos/locales/en.json
// module id = 1778
// module chunks = 0